import { createStore } from 'store-utils';
import { PendingInvitationMember } from '../types/members-types';

const InviteMemberStore = createStore<InviteMemberState>(
  {
    isModalVisible: false,
    isInviteButtonEnabled: false,
    isInviteButtonLoading: false,
    pendingInvitationMembers: [],
    hasErrorMessage: false,
    errorMessage: '',
  },
  'Invite User Store',
);

interface InviteMemberState {
  isModalVisible: boolean;
  isInviteButtonEnabled: boolean;
  isInviteButtonLoading: boolean;
  pendingInvitationMembers: PendingInvitationMember[];
  hasErrorMessage: boolean;
  errorMessage: string;
}

export default InviteMemberStore;
